import { Avatar, AvatarGroup, Button, Icon } from "../../primitives";

type FollowerName = {
	id: string;
	displayName: string;
};

const nameParts = (displayName: string) => {
	const parts = displayName.trim().split(/\s+/).filter(Boolean);
	return {
		firstName: parts[0] ?? "",
		lastName: parts.length > 1 ? (parts[parts.length - 1] ?? "") : "",
	};
};

export const FollowerAvatarGroup = ({
	followers,
	onAdd,
	addLabel = "Add follower",
}: {
	followers: FollowerName[];
	onAdd?: () => void;
	addLabel?: string;
}) => (
	<div data-testid="follower-avatar-group" className="flex items-center gap-1">
		{followers.length > 0 && (
			<AvatarGroup overflowClassName="bg-surface-neutral">
				{followers.map((follower) => {
					const { firstName, lastName } = nameParts(follower.displayName);
					return (
						<Avatar
							key={follower.id}
							firstName={firstName}
							lastName={lastName}
							aria-label={follower.displayName}
							className="bg-surface-neutral"
						/>
					);
				})}
			</AvatarGroup>
		)}
		{onAdd && (
			<Button
				variant="ghost"
				size="sm"
				aria-label={addLabel}
				onClick={onAdd}
				className="h-6 w-6 shrink-0 rounded-full border border-dashed border-bc-default p-0 hover:bg-surface-neutral hover:border-bc-strong"
			>
				<Icon type="users" size="micro" color="secondary" />
			</Button>
		)}
	</div>
);
